import React, { ReactNode } from 'react'

interface AppBarProps {
  position?: 'static' | 'fixed' | 'absolute' | 'sticky'
  children: ReactNode
  className?: string
}

export const AppBar: React.FC<AppBarProps> = ({ position = 'static', children, className = '' }) => {
  return <header className={`app-bar app-bar--${position} ${className}`}>{children}</header>
}
